import { render, staticRenderFns } from "./PersonProfileHistoryRecords.vue?vue&type=template&id=0b2c05b6&scoped=true&"
import script from "./PersonProfileHistoryRecords.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryRecords.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryRecords.vue?vue&type=style&index=0&id=0b2c05b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2c05b6",
  null
  
)

export default component.exports